/**
 * View component for /profile
 *
 * Display logged in user's own profile information and lets them update if
 * they want.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import third-party libraries
import classNames from 'classnames';
import moment from 'moment';

// import actions
import * as userActions from '../userActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import user components
import UserProfileLayout from '../components/UserProfileLayout.js.jsx';
import UpdateProfileModal from '../components/UpdateProfileModal.js.jsx';

class UserProfile extends Base {
  constructor(props) {
    super(props);
    this.state = {
      updateModalOpen: false
      , newUserData: this.props.user || {}
      , changeCount: 0
    }
    this._bind(
      '_closeUpdateModal'
      , '_handleFormChange'
      , '_handleFormSubmit'
      , '_openUpdateModal'
    );
  }

  _openUpdateModal() {
    const { user } = this.props;
    var newUserInfo = JSON.parse(JSON.stringify(user));
    this.setState({
      updateModalOpen: true
      , newUserData: newUserInfo
    })
  }

  _closeUpdateModal() {
    this.setState({
      updateModalOpen: false
      , newUserData: {}
    });
  }

  _handleFormChange(e) {

    let newUser = _.update( this.state.newUserData, e.target.name, function() {
      return e.target.value;
    });

    /**
     * Tell child components to rerender
     *
     * NOTE: this is hacky
     */
    let changeCount = this.state.changeCount;
    changeCount++;

    this.setState({
      newUserData: newUser
      , changeCount
    });
  }

  _handleFormSubmit(e) {
    const { dispatch } = this.props;
    let newState = this.state.newUserData;
    dispatch(userActions.sendUpdateProfile(newState)).then(action => {
      this._closeUpdateModal();
    });
  }


  render() {
    const { user } = this.props;

    let isEmpty = !user._id;
    return (
      <UserProfileLayout>
        <div className="flex ">
          <section className="section ">
            <div className="yt-container">
              {/* <button className="yt-btn small u-pullRight" onClick={this._openUpdateModal}>Update Profile</button> */}
              <h1>My Profile </h1>
              <hr/>
              { !isEmpty ?
                  <div className="yt-row with-gutters ">

                    <div className="yt-col full l_75">
                      <p> <strong>Name:</strong> {user.firstName} {user.lastName}</p>
                      <p> <strong>Email:</strong> {user.username}</p>
                    </div>
                    <div className="yt-col full l_75">
                      { user.ssoProviders && user.ssoProviders.length > 0 ? 
                        <div>
                          <p><b>Your account is set up to use Single Sign On.</b></p>
                          <p>You may have a separate pre-existing Pro-ficiency password. If so, you can change that <b><Link to="/user/change-password">here</Link></b>. Otherwise, please contact your Provider directly.</p>
                          {/* <span>HAS PROVIDERS</span>
                          { user.ssoProviders.map(provider => 
                            <span className='yt-btn'>{provider}</span>
                          )} */}
                        </div>
                        :
                        <a className="yt-btn primary" href={`${window.hubUrl}/user/change-password?redirect=${window.location.href}`}>Change Password</a>
                      }
                    </div>
                  </div>
                :
                  null
              }
            </div>
          </section>
          {/* <UpdateProfileModal
            newUserData={this.state.newUserData}
            isModalOpen={this.state.updateModalOpen}
            closeModal={this._closeUpdateModal}
            changeCount={this.state.changeCount}
            handleFormChange={this._handleFormChange}
            handleFormSubmit={this._handleFormSubmit}
          /> */}
        </div>
      </UserProfileLayout>
    )
  }
}

UserProfile.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  return {
    user: store.user.loggedIn.user
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UserProfile)
);



// WEBPACK FOOTER //
// modules/user/views/UserProfile.js.jsx